import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterInline = () => {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [feedback, setFeedback] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${API}/newsletter`, { email, lang });
      setStatus("success");
      setFeedback(t.news.success);
      setEmail("");
    } catch (err) {
      if (err?.response?.status === 409) {
        setStatus("success");
        setFeedback(t.news.duplicate);
      } else {
        setStatus("error");
        setFeedback(t.news.error);
      }
    }
  };

  return (
    <div className="mt-16 rounded-3xl border p-8 sm:p-10" style={{ borderColor: "var(--gold)", background: "var(--surface-secondary)" }} data-testid="blog-newsletter">
      <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
        <Star size={11} /> {t.news.kicker}
      </p>
      <h2 className="mt-4 font-serif-display text-2xl sm:text-3xl font-semibold leading-snug">{t.news.title}</h2>
      <p className="mt-3 max-w-lg text-sm leading-relaxed" style={{ color: "var(--muted-warm)" }}>{t.news.text}</p>
      <form onSubmit={submit} className="mt-6 flex max-w-md flex-col gap-3 sm:flex-row" data-testid="blog-newsletter-form">
        <input
          data-testid="blog-newsletter-input"
          required
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.news.placeholder}
          className="flex-1 rounded-full border bg-white px-5 py-3 text-sm outline-none transition-colors duration-300 focus:border-[var(--camel)]"
          style={{ borderColor: "var(--line)" }}
        />
        <button
          type="submit"
          data-testid="blog-newsletter-submit"
          disabled={status === "loading"}
          className="pill-btn flex items-center justify-center gap-2 rounded-full px-7 py-3 text-sm font-medium text-white disabled:opacity-60"
          style={{ background: "var(--camel)" }}
        >
          {status === "loading" && <Loader2 size={14} className="animate-spin" />}
          {t.news.button}
        </button>
      </form>
      {feedback && (
        <p data-testid="blog-newsletter-feedback" className="mt-4 text-sm font-medium" style={{ color: status === "error" ? "var(--rose)" : "var(--camel)" }}>
          {feedback}
        </p>
      )}
    </div>
  );
};
